const ADD_TABLE_SUCCESS_TEXT = "La table a été ajoutée.";
const DELETE_TABLE_SUCCESS_TEXT = "La table a été supprimée.";
const UPDATE_TABLE_SUCCESS_TEXT = "Le table a été modifiée.";
export const ADD_TABLE_SUCCESS = ADD_TABLE_SUCCESS_TEXT;
export const DELETE_TABLE_SUCCESS = DELETE_TABLE_SUCCESS_TEXT;
export const UPDATE_TABLE_SUCCESS = UPDATE_TABLE_SUCCESS_TEXT;


const ADD_TABLELINK_SUCCESS_TEXT = "Le lien de tables a été ajouté.";
const DELETE_TABLELINK_SUCCESS_TEXT = "Le lien de tables a été supprimé.";
const UPDATE_TABLELINK_SUCCESS_TEXT = "Le lien de tables a été modifié.";
export const ADD_TABLELINK_SUCCESS = ADD_TABLELINK_SUCCESS_TEXT;
export const DELETE_TABLELINK_SUCCESS = DELETE_TABLELINK_SUCCESS_TEXT;
export const UPDATE_TABLELINK_SUCCESS = UPDATE_TABLELINK_SUCCESS_TEXT;


// WEBPACK FOOTER //
// ./src/successes/tables.js